<template>
  <div>
    <Head :title="`Editar Categoria de producto`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/product-categories">Categoria de producto</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-xl shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar Categoria de producto</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Actualizar categoria de producto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    productCategory: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.productCategory?.name,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/product-categories/${this.productCategory.id}`)
    },
    destroy() {
      if (confirm('Estas seguro que quieres eliminar esta categoria de producto?')) {
        this.$inertia.delete(`/product-categories/${this.productCategory.id}`)
      }
    },
  },
}
</script>
